var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill:#e71f19;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-460 -5149)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(460 5149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11,2a9,9,0,1,0,9,9,9.01,9.01,0,0,0-9-9m0-2A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
    transform: "translate(461 5150)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOk);
export default __webpack_public_path__ + "static/media/icon_OK.0f8def8aeaf37a3a70c879a7f1069313.svg";
export { ForwardRef as ReactComponent };